import * as types from '@/redux/actionTypes';

const initState = {
  loading: false,
  listLoading: false,

  jobsFollowedEntities: {},
  entities: {},
  contractEntities: {}, // 职位和合约对应的唯一数据
  relatedJobEntities: {}, // 所有和猎头相关的职位，（现在开放和曾经开放并推荐了候选人的职位），包含负责人和协助人信息
  idList: [],
};

function jobs(state = initState, { type, payload }) {
  switch (type) {
    case types.LOAD_JOB_LIST: {
      return {
        ...state,
        listLoading: payload,
      };
    }

    case types.LOAD_JOB: {
      return {
        ...state,
        loading: payload,
      };
    }

    case types.UPDATE_JOB: {
      const entities = { ...state.entities };
      const contractEntities = { ...state.contractEntities };
      if (payload.job) {
        entities[payload.job.id] = { ...entities[payload.job.id], ...payload.job };

        contractEntities[`${payload.job.id}_${payload.job.contractId}`] = {
          ...contractEntities[`${payload.job.id}_${payload.job.contractId}`],
          ...payload.job,
        };
      }
      return {
        ...state,
        entities,
        contractEntities,
      };
    }

    case types.UPDATE_JOB_LIST: {
      const entities = state.entities;
      const newEntities = payload.jobs.reduce((_entities, job) => {
        _entities[job.id] = { ...(entities[job.id] || {}), ...job };
        return _entities;
      }, state.entities);

      const newContractEntities = payload.jobs.reduce((_entities, job) => {
        const id = `${job.id}_${job.contractId}`;
        _entities[id] = { ...(entities[id] || {}), ...job };
        return _entities;
      }, state.contractEntities);

      const idList = payload.jobs.map((job) => job.id);
      return {
        ...state,
        entities: newEntities,
        contractEntities: newContractEntities,
        idList,
      };
    }

    case types.UPDATE_RELATED_JOBS: {
      const entities = state.relatedJobEntities;
      const newEntities = payload.jobs.reduce((_entities, job) => {
        _entities[job.id] = { ...(entities[job.id] || {}), ...job };
        return _entities;
      }, {});
      return {
        ...state,
        relatedJobEntities: newEntities,
      };
    }

    default:
      return state;
  }
}

export default jobs;
